"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var mobx_react_1 = require("mobx-react");

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var shared_1 = require("../../../../../shared");

var Row_meta_1 = require("./Row.meta");

var TableComponentBase_1 = require("../TableComponentBase");

var mobx_1 = require("mobx");

var ChildRows_1 = __importDefault(require("../ChildRows"));

var Cell_1 = __importDefault(require("../Cell"));

var RowHeadCell_1 = __importDefault(require("../RowHeadCell"));

var Row =
/** @class */
function (_super) {
  __extends(Row, _super);

  function Row(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Row_meta_1.ROW_CATEGORY_KEY;
    _this.componentKey = Row_meta_1.ROW_COMPONENT_KEY;

    _this.initialize = function () {
      if (_this.grouping) {
        _this.toggleExpanded(!!_this.row._expanded);
      }
    };

    _this.childRows = [];
    _this.expanded = false;
    _this.fetchingChildren = false;

    _this.toggleExpanded = function (explicitValue) {
      if (!_this.isLastGrouping) {
        var value = typeof explicitValue === 'boolean' ? explicitValue : !_this.expanded;
        _this.expanded = value;

        if (_this.expanded) {
          _this.fetchChildren();
        }
      }
    };

    _this.fetchChildren = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var grouping, queryStore, queryResponse;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              grouping = this.grouping;
              if (!(grouping && grouping.getRowsQuery && (!this.childRows || this.childRows.length === 0))) return [3
              /*break*/
              , 4];
              this.fetchingChildren = true;
              queryStore = this.table.props.queryStore;
              if (!queryStore) return [3
              /*break*/
              , 3];
              if (!grouping.onFetchChildren) return [3
              /*break*/
              , 2];
              return [4
              /*yield*/
              , grouping.onFetchChildren(this.row, queryStore)];

            case 1:
              _a.sent();

              _a.label = 2;

            case 2:
              queryResponse = queryStore.query(grouping.getRowsQuery, {
                responseContext: {
                  grouping: grouping,
                  row: this.row
                }
              });
              this.childRows = queryResponse;
              _a.label = 3;

            case 3:
              this.fetchingChildren = false;
              _a.label = 4;

            case 4:
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    _this.getClassName = function (className, rowIndex, grouping) {
      var classNames = [];

      if (className) {
        classNames.push(className);
      }

      var groupClassName = grouping && grouping.id && "ksys-table-row-group-" + ksys_app_template_1.utils.changeCase.paramCase(grouping.id);

      if (groupClassName) {
        classNames.push(groupClassName);
      }

      if (typeof rowIndex === 'number') {
        var isEven = (rowIndex + 1) % 2 === 0;
        var evenClassName = "ksys-table-row-even";
        var oddClassName = "ksys-table-row-odd";
        classNames.push(isEven ? evenClassName : oddClassName);
      }

      return classNames.join(' ');
    };

    _this.initialize();

    return _this;
  }

  Object.defineProperty(Row.prototype, "parentComponentKey", {
    get: function get() {
      return Row_meta_1.ROW_PARENT_COMPONENT_KEY;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Row.prototype, "tableEventsKey", {
    get: function get() {
      return 'row';
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Row.prototype, "isLastGrouping", {
    get: function get() {
      return !this.grouping || !this.grouping.getRowsQuery || !this.grouping.childGroup;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Row.prototype, "row", {
    get: function get() {
      return this.props.row;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Row.prototype, "rowIndex", {
    get: function get() {
      return this.props.rowIndex;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Row.prototype, "grouping", {
    get: function get() {
      return this.props.grouping;
    },
    enumerable: true,
    configurable: true
  });

  Row.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        children = _a.children,
        className = _a.className,
        configuration = _a.configuration,
        componentStyle = _a.componentStyle,
        componentStyleProps = _a.componentStyleProps,
        table = _a.table,
        row = _a.row,
        rowIndex = _a.rowIndex,
        grouping = _a.grouping,
        otherProps = __rest(_a, ["children", "className", "configuration", "componentStyle", "componentStyleProps", "table", "row", "rowIndex", "grouping"]);

    var columns = __spreadArrays(this.grouping && this.grouping.columns || this.table.columns);

    var events = this.getEvents(this.eventsForElement, this.row, this.rowIndex);
    var rowClassName = this.getClassName(className, rowIndex, grouping);
    return react_1.default.createElement(react_1.Fragment, null, react_1.default.createElement("tr", __assign({
      className: rowClassName
    }, events, otherProps), columns.map(function (column, columnIndex) {
      var cellKey = _this.getCellKey(row, rowIndex, column);

      var cellValue = _this.table.logic.getValue(row, column, _this.table.translationContext, _this);

      var cellStyleProps = _this.getCellStyleProps(row, rowIndex, column, columnIndex, cellValue);

      var cellProps = __assign(__assign({}, cellStyleProps), {
        table: table,
        column: column,
        columnIndex: columnIndex,
        row: row,
        rowIndex: rowIndex,
        cellValue: cellValue,
        key: cellKey
      });

      if (column.isRowHeader) {
        return react_1.default.createElement(RowHeadCell_1.default, __assign({}, cellProps));
      }

      return react_1.default.createElement(Cell_1.default, __assign({}, cellProps));
    })), !this.isLastGrouping && !this.fetchingChildren && this.expanded && this.childRows && this.childRows.length > 0 && react_1.default.createElement(ChildRows_1.default, {
      table: this.table,
      rows: this.childRows,
      grouping: this.grouping
    }));
  };

  __decorate([mobx_1.observable.ref], Row.prototype, "childRows", void 0);

  __decorate([mobx_1.observable.ref], Row.prototype, "expanded", void 0);

  __decorate([mobx_1.observable.ref], Row.prototype, "fetchingChildren", void 0);

  __decorate([mobx_1.action], Row.prototype, "toggleExpanded", void 0);

  __decorate([mobx_1.action], Row.prototype, "fetchChildren", void 0);

  __decorate([mobx_1.computed], Row.prototype, "isLastGrouping", null);

  __decorate([mobx_1.computed], Row.prototype, "row", null);

  __decorate([mobx_1.computed], Row.prototype, "rowIndex", null);

  __decorate([mobx_1.computed], Row.prototype, "grouping", null);

  Row = __decorate([mobx_react_1.observer], Row);
  return Row;
}(TableComponentBase_1.TableComponentBase);

exports.Row = Row;
var StyledRow = shared_1.InjectedStyledComponent(Row, Row_meta_1.ROW_CATEGORY_KEY, Row_meta_1.ROW_PARENT_COMPONENT_KEY, [Row_meta_1.ROW_COMPONENT_KEY]);
exports.default = StyledRow;